import React from 'react';
import { COLORS } from '../App';

const ACTION_LABELS = {
  summarize: '3-Sentence Summary',
  extract_numbers: 'Key Numbers',
  ask: 'Claude Response',
};

export default function QuickActionResult({ action, content, customPrompt }) {
  const isNumberList = action === 'extract_numbers';

  const formatted = isNumberList
    ? content.split('\n').filter(l => l.trim()).map((line, i) => (
        <div key={i} style={{
          padding: '5px 10px', borderBottom: `1px solid ${COLORS.border}`,
          fontSize: 12, color: COLORS.text, display: 'flex', gap: 8, alignItems: 'flex-start',
        }}>
          <span style={{ color: COLORS.textLight, flexShrink: 0, minWidth: 14, fontSize: 10, paddingTop: 2 }}>{i + 1}.</span>
          <span>{line.trim()}</span>
        </div>
      ))
    : null;

  return (
    <div style={{ background: '#F8F9FA', borderRadius: 6, border: `1px solid ${COLORS.border}`, overflow: 'hidden' }}>
      <div style={{
        padding: '6px 12px', background: COLORS.navy,
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      }}>
        <span style={{ fontSize: 11, fontWeight: 700, color: COLORS.gold }}>
          {ACTION_LABELS[action] || action}
        </span>
        {action === 'ask' && customPrompt && (
          <span style={{ fontSize: 10, color: '#9CA3AF', maxWidth: 280, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            "{customPrompt}"
          </span>
        )}
      </div>
      {isNumberList ? (
        <div>{formatted}</div>
      ) : (
        <div style={{ padding: '10px 14px', fontSize: 13, color: COLORS.text, lineHeight: 1.65 }}>
          {content}
        </div>
      )}
    </div>
  );
}
